import React, { memo, useState, useEffect } from 'react';

function RewardedAdPrompt({ powerUpType, onWatchAd, onDismiss }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);

  const typeLabel = powerUpType === 'undo' ? 'Undo' : powerUpType === 'bomb' ? 'Bomb' : 'Refresh';
  const typeIcon = powerUpType === 'undo' ? '\u21BA' : powerUpType === 'bomb' ? '\uD83D\uDCA3' : '\u21BB';

  return (
    <div className={`rewarded-ad-prompt${visible ? ' rewarded-ad-visible' : ''}`}>
      <div className="rewarded-ad-icon">{typeIcon}</div>
      <h3 className="rewarded-ad-title">Free {typeLabel}!</h3>
      <p className="rewarded-ad-text">
        Watch a short video to get 1 free {typeLabel}.
      </p>
      <button className="rewarded-ad-watch" onClick={onWatchAd}>
        Watch Video
      </button>
      <button className="rewarded-ad-dismiss" onClick={onDismiss}>
        No Thanks
      </button>
    </div>
  );
}

export default memo(RewardedAdPrompt);
